import { mergeSx } from "@/utils";

import { Icon } from "@/components/Icon";
import type { LinkIconProps } from "@/types";

import { useMemo } from "react";
import { linkIconBaseSx } from "./styles";

export function LinkIcon({ sx, className, ...props }: LinkIconProps) {
  const mergedSx = useMemo(() => mergeSx(linkIconBaseSx, sx), [sx]);
  return (
    <Icon {...props} sx={mergedSx} className={`${className ?? ""} LinkIcon`} />
  );
}

LinkIcon.displayName = "Link.Icon";
